"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationVersionState = void 0;
var ImplementationVersionState;
(function (ImplementationVersionState) {
    ImplementationVersionState["UP_TO_DATE"] = "UP_TO_DATE";
    ImplementationVersionState["OUTDATED"] = "OUTDATED";
})(ImplementationVersionState = exports.ImplementationVersionState || (exports.ImplementationVersionState = {}));
//# sourceMappingURL=safe-info.js.map